import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { IconButton, SxProps } from '@mui/material';

type Props = {
  onClick: () => void;
  position: 'left' | 'right';
  sx?: SxProps;
};

const Arrow = ({ onClick, position, sx }: Props) => {
  const isLeft = position === 'left';
  return (
    <IconButton
      onClick={onClick}
      sx={{
        position: 'absolute',
        top: '50%',
        [position]: 16,
        transform: 'translateY(-50%)',
        color: 'white',
        border: '1px solid',
        zIndex: 1,
        ...sx,
      }}
    >
      {isLeft ? <ArrowBack /> : <ArrowForward />}
    </IconButton>
  );
};
export default Arrow;
